import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-6 sm:p-8" }
const _hoisted_2 = { class: "flex items-center justify-between mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-[#6CC551] text-xs font-bold uppercase tracking-widest mb-1" }, "Documents"),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-extrabold text-[#1E2833]" }, "View Documents")
], -1)
const _hoisted_4 = {
  class: "bg-white rounded-2xl overflow-hidden mb-5",
  style: {"border":"1px solid #f3f4f6"}
}
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center py-16"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 rounded-full border-4 border-[#6CC551] border-t-transparent animate-spin" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "w-full text-sm text-left"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", {
  class: "text-xs text-[#1E2833] uppercase bg-[#6CC551]/10",
  style: {"border-bottom":"1px solid #f3f4f6"}
}, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "Title"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "Download"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "Edit"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "Delete")
  ])
], -1)
const _hoisted_10 = {
  class: "px-6 py-4",
  style: {"color":"#6b7280"}
}
const _hoisted_11 = {
  class: "px-6 py-4 font-medium",
  style: {"color":"#111827"}
}
const _hoisted_12 = { class: "px-6 py-4" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "px-6 py-4" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "px-6 py-4" }
const _hoisted_17 = ["onClick"]

import { url } from '@/functions/endpoint';
import { encryptString } from '@/functions/encryption';
import axios from 'axios';
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import SuccessMessage from "@/components/SuccessMessage.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import DeleteModal from "@/components/DeleteModal.vue";
import Pagination from '@/components/Pagination.vue';
import EmptyState from "@/components/EmptyState.vue";
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewDocuments',
  setup(__props) {

let count = ref(0);
const documentId = ref();
const router = useRouter();
let successMessage = ref('');
let showSuccessMessage = ref(false);
const loading = ref(false);
let errorAlert = ref(false);
let errorMessage = ref('');
let emptyState = ref(false);
const perPage = ref(12);
const currentPage = ref(1);

const calculatePostNumber = (index: number) => {
  return (currentPage.value - 1) * perPage.value + index + 1;
};

const editDocument = (id: number) => {
  router.push({ name: 'EditDocument', params: { id: encryptString(id.toString()) } });
};

const deleteModal = ref(false);
const openDeleteModal = (id: number) => {
  documentId.value = id;
  deleteModal.value = true;
};

const closeDeleteModal = () => {
  deleteModal.value = false;
};

const deleteDocument = () => {
  axios.delete(`${url}/department-document/delete/${documentId.value}`)
    .then((response) => {
      deleteModal.value = false;
      successMessage.value = response.data?.message ?? 'Deleted successfully';
      showSuccessMessage.value = true;

      const deletedIndex = allDocuments.value.findIndex((item: any) => item.id === Number.parseInt(documentId.value));
      if (deletedIndex !== -1) allDocuments.value.splice(deletedIndex, 1);
      if (allDocuments.value.length === 0) emptyState.value = true;

      setTimeout(() => { showSuccessMessage.value = false; }, 2000);
    })
    .catch((error) => {
      deleteModal.value = false;
      errorAlert.value = true;
      setTimeout(() => { errorAlert.value = false; }, 2500);
      errorMessage.value = error.message;
    });
};

const allDocuments: any = ref([]);

const fetchNewsItems = () => {
  loading.value = true;
  emptyState.value = false;

  axios.get(`${url}/department-document`, { params: { page: currentPage.value, limit: perPage.value } })
    .then((response: any) => {
      const data = response.data;
      if (Array.isArray(data) && Array.isArray(data[1])) {
        allDocuments.value = data[1];
        count.value = data[0]?.totalLength ?? 0;
      } else {
        allDocuments.value = Array.isArray(data) ? data : [];
        count.value = allDocuments.value.length;
      }
      emptyState.value = allDocuments.value.length === 0;
    })
    .catch((error: any) => {
      console.error(error);
      allDocuments.value = [];
      emptyState.value = true;
    })
    .finally(() => {
      loading.value = false;
    });
};

watch(currentPage, fetchNewsItems);
fetchNewsItems();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_router_link, {
          to: "/admin/add-document",
          class: "inline-flex items-center gap-2 px-4 py-2 bg-[#6CC551] hover:bg-green-600 text-white text-sm font-semibold rounded-xl transition-colors"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" + Add Document ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createElementBlock("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allDocuments.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id,
                    class: "transition-colors",
                    style: {"border-bottom":"1px solid #f9fafb"},
                    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (($event.currentTarget as HTMLElement).style.background='#f9fafb')),
                    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (($event.currentTarget as HTMLElement).style.background=''))
                  }, [
                    _createElementVNode("td", _hoisted_10, _toDisplayString(calculatePostNumber(index)), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(item?.title?.slice(0, 80)), 1),
                    _createElementVNode("td", _hoisted_12, [
                      _createElementVNode("a", {
                        target: "_blank",
                        href: item.filename,
                        class: "text-xs font-semibold text-[#6CC551] hover:underline"
                      }, "Download", 8, _hoisted_13)
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (editDocument(item.id)),
                        class: "text-xs font-semibold text-blue-500 hover:underline"
                      }, "Edit", 8, _hoisted_15)
                    ]),
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (openDeleteModal(item.id)),
                        class: "text-xs font-semibold text-red-500 hover:underline"
                      }, "Delete", 8, _hoisted_17)
                    ])
                  ], 32))
                }), 128))
              ])
            ])),
        _createVNode(EmptyState, { showEmptyState: _unref(emptyState) }, null, 8, ["showEmptyState"])
      ]),
      _createVNode(Pagination, {
        modelValue: currentPage.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentPage).value = $event)),
        "per-page": perPage.value,
        "total-items": _unref(count)
      }, null, 8, ["modelValue", "per-page", "total-items"])
    ]),
    (deleteModal.value)
      ? (_openBlock(), _createBlock(DeleteModal, {
          key: 0,
          onDeletePost: deleteDocument,
          onCloseDeleteModal: closeDeleteModal,
          item: 'document'
        }))
      : _createCommentVNode("", true),
    _createVNode(SuccessMessage, {
      showSuccessMessage: _unref(showSuccessMessage),
      successMessage: _unref(successMessage)
    }, null, 8, ["showSuccessMessage", "successMessage"]),
    _createVNode(ErrorMessage, {
      errorAlert: _unref(errorAlert),
      errorMessage: _unref(errorMessage)
    }, null, 8, ["errorAlert", "errorMessage"])
  ], 64))
}
}

})